import { Component, OnInit } from '@angular/core';
import { AppConstants } from "../../shared/constants/app-constants";
import { DataManagerService } from "../../data/services/DataManager/data-manager.service";
import { GetStatementsAction } from '../statements/get-statements.action'
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { ErrorConstants } from "../../shared/constants/error-constants";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { StatementsModel } from '../../data/model/StatementsModel/statements.model';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import { PAYARC_DATE_FORMATS } from '../../shared/material-date-formats';
import { MatDialog } from '@angular/material/dialog';
import { DetailRow } from '../../ui/detail-card/payarc-detail-card.component';
import { RowDetailDialogComponent, RowDetailDialogData } from '../../ui/row-detail-dialog/row-detail-dialog.component';
import { sameDay } from '../../ui/date-clear/payarc-date-clear.component';

@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.css'],
    standalone: false,
    providers: [{
      provide: MAT_DATE_FORMATS,
      useValue: { ...PAYARC_DATE_FORMATS, display: { ...PAYARC_DATE_FORMATS.display, dateInput: { year: 'numeric', month: '2-digit' } } }
    }]
})
export class StatementsComponent extends GetStatementsAction implements OnInit {
  statementlist: ApiResponseModel<StatementsModel>;
  requestFailed = false;
  stamentservice: string;
  from_date: Date = new Date();
  to_date: Date = new Date();

  constructor(
    dataManager: DataManagerService, private datePipe: DatePipe, snackBar: MatSnackBar,
    private matDialog: MatDialog) {
    super();
    this.snackBar = snackBar;
    this.dataManager = dataManager;
    this.emptyListMsg = ErrorConstants.statementErrorMsg[0];
    this.setDates();
    this.statementlist = new ApiResponseModel();
    this.stamentservice = '/merchant_statements';
    this.getListUrl = AppConstants.BASE_URL + this.stamentservice;
  }

  ngOnInit() {
    this.openAdfReport();
  }

  onFromMonthSelected(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.from_date = new Date(normalizedMonth.getFullYear(), normalizedMonth.getMonth(), 1);
    this.checkdate();
    datepicker.close();
  }

  onToMonthSelected(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    this.to_date = new Date(normalizedMonth.getFullYear(), normalizedMonth.getMonth() + 1, 0);
    this.checkdate2();
    datepicker.close();
  }

  checkdate() {
    if (!this.isNull(this.from_date) && this.from_date.toString() === 'Invalid Date') {
      this.from_date = null;
    }
  }

  checkdate2() {
    if (!this.isNull(this.to_date) && this.to_date.toString() === 'Invalid Date') {
      this.to_date = null;
    }
  }

  openAdfReport(): void {
    if (this.isNull(this.from_date) || this.isNull(this.to_date) || this.from_date > this.to_date) {
      this.showSnackBar('Enter valid date.', 'Ok', 3000);
    } else {
      this.loadFlag = true;
      this.from =  this.datePipe.transform(this.from_date, 'yyyy-MM-dd');
      this.to = this.datePipe.transform(this.to_date, 'yyyy-MM-dd');
      this.setUrl();
    }
  }

  /** The API needs a range, so "clear" goes back to the default one. */
  get datesChanged(): boolean {
    const today = new Date();
    return !sameDay(this.from_date, new Date(today.getFullYear(), 0, 1)) || !sameDay(this.to_date, today);
  }

  clearDates() {
    this.setDates();
    this.openAdfReport();
  }

  setDates() {
    const today = new Date();
    this.from_date = new Date(today.getFullYear(), 0, 1);
    this.to_date = new Date();
  }

  protected getListRes(response) {
    this.loadFlag = false;
    this.requestFailed = false;
    this.statementlist = response;
    this.metadata = response.meta.pagination;
  }
  protected getListErr(error: any) {
    this.loadFlag = false;
    this.requestFailed = true;
    this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.statementErrorMsg) || 'Something went wrong.';
  }

  download_statement(id) {
    this._getstatementPdf = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_STATEMENTS + '/' + id
    this.getStatementPdf();
    this.showSnackBar('File is loading.', 'Ok', 3000);
  }
  protected passStatementPdfResponse(res: any) {
    const downloadURL = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = "statement.pdf";
    link.click();
  }

  protected passStatementPdfError(err: any) {
  }

  /**
   * Preview (eye button). The tab is opened synchronously in the click handler: browsers only allow a
   * new tab during the user's gesture, and the old code opened it after the PDF request (a
   * target=_blank link clicked from the response callback), which popup blockers silently dropped -
   * "the preview does nothing". Each click keeps its own tab and request in this closure, so quick
   * repeated previews can't swap PDFs between tabs.
   */
  view_statement(id) {
    const win = window.open('', '_blank');
    if (win) {
      win.document.title = 'Statement';
      win.document.body.textContent = 'Loading statement…';
    }
    const url = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_STATEMENTS + '/' + id;
    this.dataManager.getRequestPdf(url, 0).subscribe(
      res => this.showPreview(win, new Blob([res], { type: 'application/pdf' })),
      () => this.previewFailed(win),
    );
    this.showSnackBar('File is loading.', 'Ok', 3000);
  }

  private showPreview(win: Window | null, pdf: Blob): void {
    if (win && !win.closed) {
      const url = window.URL.createObjectURL(pdf);
      win.location.href = url;
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } else {
      // tab blocked (or closed meanwhile): download instead of silently doing nothing
      this.passStatementPdfResponse(pdf);
      this.showSnackBar('Preview was blocked by the browser - the statement was downloaded instead.', 'Ok', 4000);
    }
  }

  private previewFailed(win: Window | null): void {
    if (win && !win.closed) {
      win.close();
    }
    this.showSnackBar('Unable to load the statement preview.', 'Ok', 3000);
  }

  // Required by GetStatementsAction; the preview no longer goes through its shared getStatementPdfView()
  // (one request field for all clicks) - view_statement keeps each request with its own tab.
  protected passStatementPdfViewResponse(res: any) {
    this.showPreview(null, res);
  }

  protected passStatementPdfViewError() {
    this.previewFailed(null);
  }

  // One pipe instance each, and each row's accessible name computed once (the template asks on every
  // change-detection pass, for every row).
  private readonly currencyPipe = new CurrencyPipe('en-US');
  private readonly numberPipe = new DecimalPipe('en-US');
  private ariaLabels = new WeakMap<object, string>();

  /** Same formatting as the table cells: counts with separators, volumes as "$x USD", missing = "--" (0 is shown). */
  private count(v: any): string {
    return v || v == 0 ? this.numberPipe.transform(v) : '--';
  }

  private volume(v: any): string {
    return v || v == 0 ? this.currencyPipe.transform(v, 'USD', 'symbol', '1.2-2') + ' USD' : '--';
  }

  /** Accessible name of a statement row, so keyboard / screen-reader users can tell the rows apart. */
  rowAriaLabel(statement: any): string {
    let label = this.ariaLabels.get(statement);
    if (label === undefined) {
      const date = this.datePipe.transform(statement.processing_date, 'MM/dd/yyyy') || '--';
      label = `Statement ${date}, sales volume ${this.volume(statement.total_sales_volume)}. Open statement detail`;
      this.ariaLabels.set(statement, label);
    }
    return label;
  }

  /**
   * A row click / Enter (desktop and mobile) opens the statement's totals in the shared row detail
   * panel, with a Download PDF button. The row's own PDF / Preview buttons keep working on their own.
   */
  openStatementDetail(statement: any): void {
    const rows: DetailRow[] = [
      { label: 'Date', value: this.datePipe.transform(statement.processing_date, 'MM/dd/yyyy') || '--' },
      { label: 'Total Authorizations', value: this.count(statement.total_authorizations) },
      { label: 'Total Captured Sales', value: this.count(statement.total_sales_count) },
      { label: 'Total Sales Volume', value: this.volume(statement.total_sales_volume) },
      { label: 'Total Refunds', value: this.count(statement.total_refund_count) },
      { label: 'Total Refund Volume', value: this.volume(statement.total_refund_amount) },
    ];
    const data: RowDetailDialogData = {
      title: 'Statement detail',
      rows,
      action: { label: 'Download PDF', run: () => this.download_statement(statement.id) },
    };
    this.matDialog.open(RowDetailDialogComponent, {
      data,
      panelClass: 'pa-shell-dialog',
      width: '560px',
      maxWidth: '94vw',
      maxHeight: '90vh',
      autoFocus: false,
    });
  }

  paginate(paginateExtension) {
    this.getList(paginateExtension);
  }
}
